import VehicleEdit from "@/pages/vehicles/VehicleEdit";
import { openContextModal } from "@mantine/modals";

const VehicleEditModal = ({ context, id, innerProps }) => {
  const handleSave = (data) => {
    context.closeModal(id);
    innerProps.onSave(data);
  };

  const handleCancel = () => {
    context.closeModal(id);
  };

  return <VehicleEdit vehicleId={innerProps.vehicleId} onSave={handleSave} onCancel={handleCancel} />;
};

const openVehicleEditModal = (innerProps) => {
  openContextModal({
    modal: "VehicleEditModal",
    size: "lg",
    title: "Edit Vehicle",
    centered: true,
    withCloseButton: true,
    closeOnClickOutside: false,
    closeOnEscape: false,
    innerProps,
  });
};

export { VehicleEditModal, openVehicleEditModal };
